import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Header } from 'shared/ui/header'

import s from './styles.module.scss'

interface Props {
  difficult?: boolean
}

export const HeaderCalendar: FC<Props> = ({ difficult }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  return (
    <div className={clsx(difficult && s.header)}>
      <Header
        title={t('when')}
        isFixed={false}
        actionLeft={
          <AppIcon
            id={AllIcons.ARROW_LEFT}
            className={s.icon}
            onClick={() => navigate(-1)}
          />
        }
      />
    </div>
  )
}
